(function() {
  'use strict';

  angular.module('ringbaPortal').directive('trCampaign', trCampaign);

  function trCampaign() {
    const directive = {
      restrict: 'E',
      scope: {},
      controller: 'CampaignController',
      controllerAs: 'vm',
      bindToController: true,
      templateUrl: '/scripts/components/campaigns/campaign.view.html'
    };
    return directive;
  }
})();
